export const ncdRouteMap = {
  gestion: '/ncd/gestion',
  nuevo: '/ncd/nuevo',
  modificar: `/ncd/modificar`,
}
